const filterSearch = (filter_group_id, input_id) => {
    const filterSelector = '.findify-filters-checkbox-item';
    const filterTextSelector = 'label';

    const filterGroupElement = document.getElementById(filter_group_id);
    const filters = filterGroupElement.querySelectorAll(filterSelector);
    const input = document.getElementById(input_id);

    const inputHandler = (e) => {
        const value = e.target.value.trim().toLowerCase();
        filters.forEach(item => {
            const text = item.querySelector(filterTextSelector).innerText.trim().toLowerCase();
            const shouldHide = value && !text.includes(value);
            item.setAttribute("aria-hidden", shouldHide.toString());
        });
    };

    input.addEventListener("input", inputHandler);
};

const collapseFilter = (element_id) => {
    const filterGroupElement = document.getElementById(element_id);
    const allFilters = document.querySelectorAll('.findify-filter-group');
    let currentlyOpenFilter = null;
    const [header, body] = filterGroupElement.querySelectorAll('div');

    const plusIcon = header.querySelector('.icon--plus');
    const minusIcon = header.querySelector('.icon--minus');

    const headerClickHandler = (e) => {
        e.preventDefault();
        const isOpen = body.getAttribute("data-opened") === "true";

        allFilters.forEach(filter => {
            const [filterHeader, filterBody] = filter.querySelectorAll('div');
            filterBody.setAttribute("data-opened", "false");
            filterHeader.querySelector('.icon--plus').style.display = 'inline';
            filterHeader.querySelector('.icon--minus').style.display = 'none';
        });

        if (!isOpen) {
            body.setAttribute("data-opened", "true");
            plusIcon.style.display = 'none';
            minusIcon.style.display = 'inline';
            currentlyOpenFilter = filterGroupElement;
        } else {
            body.setAttribute("data-opened", "false");
            plusIcon.style.display = 'inline';
            minusIcon.style.display = 'none';
            currentlyOpenFilter = null;
        }
    };

    const documentClickHandler = (e) => {
        if (currentlyOpenFilter && !currentlyOpenFilter.contains(e.target)) {
            const [openHeader, openBody] = currentlyOpenFilter.querySelectorAll('div');
            openBody.setAttribute("data-opened", "false");
            openHeader.querySelector('.icon--plus').style.display = 'inline';
            openHeader.querySelector('.icon--minus').style.display = 'none';
            currentlyOpenFilter = null;
        }
    };

    header.addEventListener("click", headerClickHandler);
    document.addEventListener("click", documentClickHandler);
};